import styled from "styled-components";

export const Container = styled.div`
    padding: 8px 16px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    flex: 1;

    .ant-form-item {
        flex-direction: column;
        align-items: start;
    }

    .ant-form-item-control {
        width: 100%;
    }

    .ant-form-item-required::before {
      content: none !important;
    }

    .ant-form-item-required::after {
        display: inline-block !important;
        margin-left: 4px !important;
        color: red;
        font-size: 14px !important;
        line-height: 1 !important;
        content: "*" !important;
    }
`;

export const OperationsHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
`;

export const OperationsIcon = styled.div`
    width: 24px;
    height: 24px;
    background: #e8f5e8;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const MaterialIcons = styled.span<{ color?: string }>`
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;

    font-size: 16px;
    color: ${({ color }) => color || "#009157"};
`;

export const OperationsTitle = styled.span`
    font-size: 14px;
    font-weight: 600;
    color: #1976d2;
`;

export const OperationsCount = styled.span`
    background: #009157;
    color: white;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
`;

export const SelectAllContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 0;
    margin-bottom: 8px;
    border-bottom: 1px solid #f0f0f0;
`;

export const SelectAll = styled.label`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #666;
    cursor: pointer;

    input {
        width: 16px;
        height: 16px;
        accent-color: #2196f3;
    }
`;

export const BulkActions = styled.div<{ buttonDeleted?: boolean }>`
    display: flex;
    gap: 8px;

    button {
        border: none;
        padding: 6px 12px;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 500;
        cursor: not-allowed;
        display: flex;
        align-items: center;
        gap: 4px;
        transition: all 0.2s ease;

        background: #f44336;
        background-color: ${({ buttonDeleted }) => (buttonDeleted ? "#f44336" : "#e0e0e0")};
        color: ${({ buttonDeleted }) => (buttonDeleted ? "#fff" : "#9e9e9e")};
        cursor: ${({ buttonDeleted }) => (buttonDeleted ? "pointer" : "not-allowed")};
    }
`;

export const OperationsList = styled.div`
    flex: 1;
    overflow-y: auto;
`;

export const OperationItem = styled.label`
    margin-bottom: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;

    background: #f8f9fa;
    border-radius: 6px;
    padding: 12px;
    display: flex;
    align-items: center;
    gap: 10px;
    border: 1px solid #e9ecef;
    transition: all 0.3s ease;

    .selected {
        border: 1px solid #2196f3;
        box-shadow: 0 4px 12px rgba(33, 150, 243, 0.15);
        transform: translateY(-2px);
        background: #fafbff;
    }
`;

export const OperationContent = styled.div`
    display: flex;
    gap: 12px;
    flex: 1;
`;

export const OperationCheckbox = styled.div`
    margin-top: 2px;

    > input {
        width: 16px;
        height: 16px;
        accent-color: #2196f3;
    }
`;

export const OperationDetails = styled.div`
    flex: 1;
`;

export const OperationName = styled.div`
    font-size: 13px;
    font-weight: 600;
    color: #424242;
    margin-bottom: 2px;
`;

export const OperationMeta = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 8px;
`;

export const MetaItem = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #757575;
`;

export const OperationTags = styled.div`
    display: flex;
    gap: 8px;
`;

export const OperationTagsOperations = styled.span`
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;

    background: #e3f2fd;
    color: #1976d2;
`;

export const OperationTagsTalhoes = styled(OperationTagsOperations)`
    background: #e3f2fd;
    color: #1976d2;
`;

export const OperationActions = styled.div`
    position: absolute;
    top: 16px;
    right: 16px;
    display: flex;
    gap: 4px;
    transition: opacity 0.2s ease;
`;

export const ActionBtn = styled.button`
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 6px;
    background: #f5f5f5;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
`;

export const ButtonIcon = styled.button<{ isDeleting?: boolean }>`
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 6px;
    background: #f5f5f5;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;

    cursor: ${({ isDeleting }) => (isDeleting ? "not-allowed" : "pointer")};

    :hover {
        background: #e3f2fd;
        color: #1976d2;
        ${({ isDeleting }) => isDeleting && "opacity: 0.5;"}
    }
`;

export const ButtonIconDelete = styled(ButtonIcon)<{ isDeleting?: boolean }>`
    cursor: ${({ isDeleting }) => (isDeleting ? "not-allowed" : "pointer")};
    
    :hover {
        background-color: #ffebee;
        ${({ isDeleting }) => isDeleting && "opacity: 0.5;"}
    }
    :hover span {
        color: ${({ isDeleting }) => (isDeleting ? "#9e9e9e" : "#d32f2f")};
    }
`;

export const Search = styled.input`
    border-radius: 6px;
    padding: 8px;
    border: 1px solid #e9ecef;
    background: #fff;
`;